/* eslint-disable import/prefer-default-export */

export const TEAM_MEMBERSHIP_CHANGED = 'TEAM_MEMBERSHIP_CHANGED';
export const ORIGINAL_TEAM_MEMBERSHIP_CHANGED = 'ORIGINAL_TEAM_MEMBERSHIP_CHANGED';
